<script>
import number from "@/mixins/number";
import DatePicker from "vue2-datepicker";
import dailyReportControlRules from "@/mixins/dailyReportControlRules";

export default {
  name: "ServiceInputSP",
  components: {
    DatePicker,
  },
  mixins: [number, dailyReportControlRules],
  props: {
    wasteOrServiceByDailyReport: {
      type: Object,
      required: true,
    },
    dailyReport: {
      type: Object,
      required: true,
    },
    errors: {
      type: Object,
      default: () => {
      },
    },
    indexWasteOrService: {
      type: Number,
      default: 0,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    controlRules: {
      type: Object | null,
    },
    canBeDelete: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    scheduleIdWithSubId(wasteOrService) {
      return [
        this.dailyReport.schedule_id,
        wasteOrService?.daily_report_sub_id,
      ].filter(x => !!x).join('-')
    },
    serviceName(wasteOrService) {
      let wasteOrServiceInJson = this.getTargetWasteOrServiceFromJson(wasteOrService.wastes_or_services_by_work_order_id);
      return wasteOrServiceInJson?.service?.name;
    },
    getProductNameByService(estimate) {
      return estimate.invoice_product_name;
    },
    getZzUnit(estimate) {
      return estimate.zz_unit?.unit;
    },
    getZzUnitBGColorClass(estimate) {
      return (estimate.zz_unit.id != '06');
    },
    deleteService() {
      this.$emit('deleteService', this.wasteOrServiceByDailyReport);
    },
    getTargetWasteOrServiceFromJson(targetId){
      return this.dailyReport.work_order_json.waste_or_service_by_work_order.find((item) => item.id == targetId);
    },
  },
  computed: {
    isApproved() {
      if (this.dailyReport.work_order_json.zz_work_order_type_id === this.$constant.work_order_type.transportation_disposal) {
        if (this.vendorSiteId) {
          return parseInt(this.wasteOrServiceByDailyReport.treatment_approved_status) === 1;
        }

        return parseInt(this.wasteOrServiceByDailyReport.transport_approved_status) === 1
      }
      return parseInt(this.wasteOrServiceByDailyReport.transport_approved_status) === 1
        || parseInt(this.wasteOrServiceByDailyReport.treatment_approved_status) === 1;
    },
    vendorSiteId() {
      return this.$route.query.vendor_site_id ?? null;
    },
  }
}
</script>
<template>
  <b-row>
    <div class="d-flex justify-content-end mt-2" v-if="canBeDelete">
      <b-btn
        style="margin-right: 5px"
        class="btn-custom-red"
        size="sm"
        @click="deleteService"
        :disabled="isApproved"
      >
        <i class="fas fa-eraser"></i> 削除
      </b-btn>
    </div>
    <div class="wosdr">
      <div class="label-wosdr">受付番号枝番：</div>
      <div class="content-wosdr">
				<span>
					{{ scheduleIdWithSubId(wasteOrServiceByDailyReport) }}
          <span v-if="isApproved">(承認済)</span>
				</span>
      </div>
    </div>
    <template>
      <div class="wosdr" v-if="isDisplayControl('waste_service_name')">
        <div class="label-wosdr">作業名称：</div>
        <div class="content-wosdr">
					<span>
						{{ serviceName(wasteOrServiceByDailyReport) }}
					</span>
        </div>
      </div>
    </template>
    <div class="input-sp-estimates" v-if="isDisplayControl('estimates')">
      <template
        v-for="(estimate, estimateIndex) in wasteOrServiceByDailyReport.estimates_by_daily_report"
      >
        <div>
          <div class="wosdr">
            <div class="label-wosdr">{{ getProductNameByService(estimate) }}</div>
            <div class="content-wosdr" :class="{bg_notice:getZzUnitBGColorClass(estimate)}">
              <b-form-input
                class="input-field"
                :disabled="isApproved"
                @keyup="setMinNumber($event)"
                type="number"
                v-model="estimate.quantity"
                min="0"
              ></b-form-input>
              <span>{{ getZzUnit(estimate) }}</span>
            </div>
            <b-row class="input-sp-error"
                 v-if="errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.estimates_by_daily_report.${estimateIndex}.quantity`]">
            <div class="error-message">
              {{
                errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.estimates_by_daily_report.${estimateIndex}.quantity`][0]
              }}
            </div>
          </b-row>
          </div>
          <div class="wosdr">
            <div class="label-wosdr">空容器数量</div>
            <div class="content-wosdr">
              <b-form-input
                class="input-field"
                :disabled="true"
                :value="estimate.number_of_rental_containers"
                type="text"
                maxLength="50"
              ></b-form-input>
            </div>
          </div>
          
        </div>
      </template>
      <template v-if="!wasteOrServiceByDailyReport.estimates_by_daily_report.length && !isLoading">
        <span>データなし。</span>
      </template>
    </div>
    <b-row class="input-sp-error"
           v-if="errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.estimates_by_daily_report`]">
      <div class="error-message">
        {{ errors[`wastes_or_services_by_daily_report.${indexWasteOrService}.estimates_by_daily_report`][0] }}
      </div>
    </b-row>
  </b-row>
</template>
<style lang="scss" scoped>
.input-sp-estimates {
  margin-bottom: 1rem;
  border: 2px solid #ccc;
  padding: 10px;
  width: 100%;
  display: inline-block;
  box-sizing: border-box;
}

.label-wosdr {
  padding: 10px 7px;
  font-weight: bold;
  min-width: 142px;
}

.content-wosdr {
  width: 100%;
  display: flex;
  align-items: center;
}

.wosdr {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
}

.input-field {
  flex: 1;
  width: 60%;
  margin-right: 5px;
}

.measurement {
  display: flex !important;
  align-items: center;
  margin-left: auto;
}

.measurement-btn {
  margin: 0px 0px 0px 0px !important;
}

.badge {
  font-size: 14px;
  padding: 8px 16px;
  background-color: #14A5FD;
}

.badge.badge-icon-custom {
  color: #14A5FD;
  padding: 2px 6px;
  background-color: #f8f9fa;
  border-radius: 50%;
  font-weight: 700;
  cursor: pointer;
}

.input-sp-error {
  margin-left: -3px;
  margin-bottom: 20px;
}

.bg_notice{
  background-color: yellow;
}
</style>
